export default "__VITE_ASSET__BDubAhjk__"